import React from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import Tickets from "../pages/Tickets/";
import Signup from "../pages/Signup/";
import Login from "../pages/Login/";
import Connections from "../pages/Connections/";
import WabaSignup from "../pages/WabaSignup/";
import Waba from "../pages/Waba/";
import MetaOnboarding from "../pages/Meta/";
import Settings from "../pages/Settings/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import QuickAnswers from "../pages/QuickAnswers/";
import ChatFlows from "../pages/ChatFlows/";
import ChatFlowEditor from "../pages/ChatFlowEditor/";
import Pixel from "../pages/Pixel/";
import Campanhas from "../pages/Campanhas/";
import Webhook from "../pages/Webhook/";
import CounterNumbers from "../pages/CounterNumbers/";
import LeadMessages from "../pages/LeadMessages/";
import Proxy from "../pages/Proxy/";
import Queues from "../pages/Queues/";
import { AuthProvider } from "../context/Auth/AuthContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { ThemeProvider } from "../context/DarkMode";
import Route from "./Route";

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={Signup} />
            <WhatsAppsProvider>
              <LoggedInLayout>
                <Route exact path="/" component={Dashboard} isPrivate />
                <Route exact path="/tickets/:ticketId?" component={Tickets} isPrivate />
                <Route exact path="/connections" component={Connections} isPrivate />
                <Route exact path="/waba" component={Waba} isPrivate />
                <Route exact path="/meta" component={MetaOnboarding} isPrivate />
                <Route exact path="/meta-onboarding" component={MetaOnboarding} isPrivate />
                <Route exact path="/waba-signup" component={WabaSignup} isPrivate />
                <Route exact path="/facebook-signup" component={WabaSignup} isPrivate />
                <Route exact path="/contacts" component={Contacts} isPrivate />
                <Route exact path="/users" component={Users} isPrivate />
                <Route exact path="/quickAnswers" component={QuickAnswers} isPrivate />
                <Route exact path="/chat-flows" component={ChatFlows} isPrivate />
                <Route
                  exact
                  path="/chat-flows/:chatFlowId"
                  component={ChatFlowEditor}
                  isPrivate
                />
                <Route exact path="/pixel" component={Pixel} isPrivate />
                <Route exact path="/campanhas" component={Campanhas} isPrivate />
                <Route exact path="/webhook" component={Webhook} isPrivate />
                <Route exact path="/counter-numbers" component={CounterNumbers} isPrivate />
                <Route exact path="/lead-messages" component={LeadMessages} isPrivate />
                <Route exact path="/Settings" component={Settings} isPrivate />
                <Route exact path="/proxy" component={Proxy} isPrivate />
                <Route exact path="/Queues" component={Queues} isPrivate />
              </LoggedInLayout>
            </WhatsAppsProvider>
          </Switch>
          <ToastContainer autoClose={3000} />
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
